// local
// export const domain = "http://127.0.0.1:8000/";

// server
// export const domain = "https://ditp-backend.kisrasprint.com/";
// export const domain = "https://thaitradeusa-admin.kisrasprint.com/";
export const domain = "https://admin.thaitradeusa.com/";
export const domain_front = "https://thaitradeusa.com/";
